import * as THREE from 'three'
import Experience from './Experience'
import DropNodes from './World/DropNodes'
import gsap from 'gsap'
import Input from './Input'
import WebUI from './WebUI'
import AudioManager from './AudioManager'
export default class SpatialCursor
{
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.camera = this.experience.camera;
        this.input = this.experience.input;
        this.webUI = this.experience.webUI;
        this.audioManager = this.experience.audioManager

        this.clickedOnAnInteractable = false;
        this.hoveredOnAnInteractable = false;

        this.input.on('mousedown', () => {
            this.handleMouseDown()
        })

        this.input.on('mouseup', () => {
            this.handleMouseUp()
        })

        this.mouse

        this.raycaster = new THREE.Raycaster();
        this.currentIntersect = {};
        this.nodes = this.experience.world.dropNodes.nodes;

        // ✅ Cache UI elements ONCE in the constructor
        this.hoverUI = document.getElementById('hover-ui');
        this.hoverHeader = document.getElementById('hover-ui-header');
        this.hoverTitle = document.getElementById('hover-ui-title');

        console.log('spatial cursor initialized');
    }

    update() {

        // if modal is open, dont do raycasting
        if(this.webUI.modalIsOpen) {
            
            // opened the modal, scale back down the 
            if (this.currentIntersect && this.currentIntersect.userData?.innerMesh) {
                gsap.to(this.currentIntersect.userData.innerMesh.scale, { 
                    x: 1, y: 1, z: 1, 
                    duration: 0.3, 
                    ease: "power2.inOut" 
                });
            }

            this.hoverUI.style.display = 'none';

            this.currentIntersect = null;
        }

        if(!this.experience.isMobile) {
            this.raycaster.setFromCamera(this.input.mouseVector, this.camera.instance);
            
        }
        else
        {
            this.raycaster.setFromCamera(new THREE.Vector2(0, 0), this.camera.instance)
        }

        const nodeIntersects = this.raycaster.intersectObjects(this.nodes);

        // ✅ Check if there is an intersection with a node
        if (nodeIntersects.length > 0) {
            if(this.webUI.modalIsOpen) {
                return;
            }
            const hoveredNode = nodeIntersects[0].object;

            // ✅ Check if the hovered node is different from the current intersect
            if (this.currentIntersect !== hoveredNode) {
               
                this.currentIntersect = hoveredNode;
                this.audioManager.playSound('cube_hover')

                // if has inner mesh, scale it up (it starts at 0.5, 0.5, 0.5)
                if (hoveredNode.userData?.innerMesh) {
                    gsap.to(hoveredNode.userData.innerMesh.scale, { 
                        x: 5, y: 5, z: 5, 
                        duration: 0.3, 
                        ease: "power2.out" 
                    });
                }

                // ✅ Use cached UI elements -- Set UI Text and set it to visible
                if (hoveredNode.userData?.info) {
                    if(this.hoverHeader ) {
                        this.hoverHeader.innerText = hoveredNode.userData.info.dropNumber || "#000";
                    }
                    if(this.hoverTitle) {
                        this.hoverTitle.innerText = hoveredNode.userData.info.title || "Drop Title";
                    }
                }

                if(!this.experience.isMobile) {
                    this.hoverUI.style.display = 'block';
                    document.body.style.cursor = 'pointer';
                }
            }
            
        } else {
            if (this.currentIntersect && this.currentIntersect.userData?.innerMesh) {
                gsap.to(this.currentIntersect.userData.innerMesh.scale, { 
                    x: 1, y: 1, z: 1, 
                    duration: 0.3, 
                    ease: "power2.inOut" 
                });
            }

            this.currentIntersect = null;
            document.body.style.cursor = 'default';

            // ✅ Use cached UI elements
            this.hoverUI.style.display = 'none';
        }

        // Convert normalized mouse coordinates (-1 to 1) to screen pixels
        const mouseX = (this.input.mouseVector.x + 1) / 2 * window.innerWidth;
        const mouseY = (1 - this.input.mouseVector.y) / 2 * window.innerHeight;

        // Move the UI to follow the mouse
        this.hoverUI.style.left = `${mouseX}px`;
        this.hoverUI.style.top = `${mouseY}px`;
    }

    handleMouseDown()
    {
        this.audioManager.playSound('click')
        this.pendingNode = null;

        // On mobile, raycast from the actual tap position
        if(this.experience.isMobile)
        {
            this.raycaster.setFromCamera(this.input.mouseVector, this.camera.instance);
            const tapIntersects = this.raycaster.intersectObjects(this.nodes);
            if(tapIntersects.length > 0 && tapIntersects[0].object.userData?.isInteractable)
            {
                this.audioManager.playSound('cube_click')
                this.clickedOnAnInteractable = true;
                this.pendingNode = tapIntersects[0].object;
                return;
            }
        }

        if(this.currentIntersect && this.currentIntersect.userData?.isInteractable)
        {
            this.audioManager.playSound('cube_click')
            this.clickedOnAnInteractable = true;
            this.pendingNode = this.currentIntersect;
        }
    }

    handleMouseUp()
    {
        if(this.clickedOnAnInteractable) {
            this.audioManager.playSound('cube_release')

            // Only open modal if user didn't scroll (tap, not drag)
            if(this.pendingNode && !this.input.didScroll)
            {
                this.webUI.showModal(this.pendingNode.userData);
            }

            this.clickedOnAnInteractable = false;
            this.pendingNode = null;
        }
    }
}